import React, { Component } from "react";
import { connect } from "react-redux"
import { PropTypes } from "prop-types"
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl
} from "react-bootstrap"
import userManager from '../../../userManager'
import { URL } from '../../../config'
import { getRequest } from '../../../utils/httpRequest'
import { division,gender } from '../../../utils/constants'
import ContentWrapper from "../../layout/ContentWrapper"
import { orange } from '../../../utils/sitecolors'
import { positivenumbers } from '../../../utils/helperfunctions'
import Athletes  from './profile'
import { getAthletes } from './api'
import styles from './styles'

const SearchBy = {
  All:'all',
  LastName:'lastName',
  MemberId:'memberID'
}
class Athlete extends Component {
 
  constructor(props)
  {
    super(props)
    this.state = 
    {
      searchBy: SearchBy.All,
      schools:[],
      athletes:[],
      schoolId:-1,
      athleteDivision:division.Varsity,
      athleteGender:gender.Men,
      prefix:'',
      suffix:'',
      lastName:'',
      searching:false,
      searchDone:false,
      token:''
    }
    this.getSchools           = this.getSchools.bind(this)
    this.populateSchools      = this.populateSchools.bind(this)
    this.handleSchoolChange   = this.handleSchoolChange.bind(this)
    this.handleDivisionChange = this.handleDivisionChange.bind(this)
    this.handleGenderChange   = this.handleGenderChange.bind(this)
    this.handlePrefixChange   = this.handlePrefixChange.bind(this)
    this.handleSuffixChange   = this.handleSuffixChange.bind(this)
    this.handleLastNameChange = this.handleLastNameChange.bind(this)
    this.disableSearchButton  = this.disableSearchButton.bind(this)
    this.handleSearch         = this.handleSearch.bind(this)
  }
  componentDidMount()
  {
    const { oidc } = this.props
    if (oidc.user == null)
    {
       userManager.signinRedirect()
    }
    else
    {
      this.getSchools()
    }
  }
  getSchools()
  {
    const schoolsendpoint = '/rankedschools'
    const token = this.props.oidc.user.access_token
    const  schoolsURL =  `${URL.event}${schoolsendpoint}` 
    const _this = this
    getRequest(schoolsURL,'json',token).then(function(response)
    {
      _this.setState({ 
        schools:response.data,
        token
      })
    })
  }
  handleSchoolChange = (event) => 
  {
    const schoolId = event.target.value
    this.setState({ 
      schoolId:schoolId, 
      athletes:[],
      searchDone:false  
    })
  }
  handleSearchByChange = (event) => 
  {
    const searchBy = event.target.value
    this.setState({ 
      searchBy,
      lastName:'',
      prefix:'',
      suffix:'', 
      athletes:[] 
    })
  }
  handleDivisionChange = (event) =>
  {
    const athleteDivision = event.target.value
    this.setState({ 
      athleteDivision, 
      athletes:[],
      searchDone:false   
    })
  }
  handleGenderChange = (event) => 
  {
    const athleteGender = event.target.value
    this.setState({ 
      athleteGender,
      athletes:[],
      searchDone:false   
    })
  }
  handleSearch()
  {
    const _this = this
    const { oidc } = this.props
    const token = oidc.user.access_token
    
    const { 
      schoolId,
      searchBy,
      athleteDivision,
      athleteGender,
      prefix,
      suffix,
      lastName
    } = this.state

    _this.setState({ searching:true,searchDone:false })
   
    const teamDivision     = athleteDivision == division.Varsity ? "V":"JV"
    const searchValue = searchBy == SearchBy.LastName ? lastName: searchBy == SearchBy.MemberId ? `${prefix}-${suffix}`:'all'
   
    getAthletes(schoolId,teamDivision,athleteGender,searchBy,searchValue,token)
    .then(function(response)
    {
      _this.setState({ 
        searching:false,
        athletes:response.data,
        searchDone:true  
      })
    })
    .catch(function(error)
    {
      console.log('Athletes getAthltes error',error )
      _this.setState({ 
        searching:false,
        athletes:[],
        searchDone:true   
      })
    })
    
  }
  handlePrefixChange = (event) => {
    const prefix = event.target.value
    this.setState({ 
      prefix, 
      athletes:[],
      searchDone:false  
    })
  }
  handleSuffixChange = (event) => {
    const suffix = event.target.value
    this.setState({ 
      suffix, 
      athletes:[],
      searchDone:false  
    })
  }
  handleLastNameChange= (event) => {
    const lastName = event.target.value
    this.setState({ 
      lastName, 
      athletes:[],
      searchDone:false  
    })
  }
  populateSchools()
  {
    //const {schools} = this.state
    const school = this.state.schools.map((school) => {
      return (<option key={school.usbcSchoolId} value={school.usbcSchoolId}>{school.schoolName}</option>)
    })
    return school
  }
  disableSearchButton()
  {
   const { schoolId, searchBy,lastName,prefix,suffix } = this.state
   const noSchoolSpecified =  (schoolId == -1)
   const noLastName = ((searchBy == SearchBy.LastName) && (lastName == ''))
   const noMemberId = ((searchBy == SearchBy.MemberId) && ((prefix == '') || (suffix == '')))
   return noSchoolSpecified || noLastName || noMemberId
  }
  render()
  {
    const { 
      athletes,
      searchBy,
      searching,
      searchDone,
      token 
    } = this.state

    const searchIcon    = searching ? 'fa fa-spinner fa-spin':'fa fa-search'
    const nbrOfAthletes = athletes.length

    // console.log('Athlete count is',athletes.length )
      
    return (
      <ContentWrapper>
        <div className="content-heading col-sm-12">Athlete Profile</div>
        <Row>
          <Col sm={12} >
            <div className="stacked-filter-panel col-sm-12">
              <FormGroup controlId="searchby" className="searchby-filter col-sm-12">
                <FormControl defaultValue='-1' componentClass="select" placeholder="All" onChange = { this.handleSchoolChange } 
                  style={{ minWidth:'275px',borderRadius:'0' }}
                >
                  <option value='-1'>Select school...</option>
                  {this.populateSchools()} 
                </FormControl>
                {
                  searchBy != SearchBy.MemberId && 
                  (<FormControl  defaultValue={division.Varsity} componentClass="select" placeholder={division.Varsity}  onChange = { this.handleDivisionChange } style={{ minWidth:'150px',borderRadius:'0' }}>
                    <option value={division.Varsity}>Varsity</option>
                    <option value={division.JV}>Junior Varsity</option>
                  </FormControl>)
                }
                {
                  searchBy != SearchBy.MemberId && 
                  (<FormControl  defaultValue={gender.Men} componentClass="select" placeholder={gender.Men}  onChange = { this.handleGenderChange } style={{ minWidth:'100px',borderRadius:'0' }}>
                  <option value={gender.Men}>Men</option>
                  <option value={gender.Women}>Women</option>  
                  </FormControl>)
                }
                <FormControl  defaultValue={SearchBy.All} componentClass="select" placeholder={SearchBy.All} onChange = { this.handleSearchByChange } style={{ minWidth:'130px',borderRadius:'0' }}>
                  <option value={SearchBy.All}>All</option>
                  <option value={SearchBy.LastName}>Name</option>
                  <option value={SearchBy.MemberId}>Member ID</option>   
                </FormControl>
                {
                  searchBy == SearchBy.LastName &&
                  (
                    <FormControl type='text' placeholder='Enter value' onChange={this.handleLastNameChange} style={{ minWidth:'220px' }}/>
                  )
                }
                {
                  searchBy == SearchBy.MemberId &&
                  ([
                    <FormControl type='text' placeholder='Prefix'  key='prefix' onChange={this.handlePrefixChange} onKeyPress={positivenumbers} style={{ minWidth:'100px',borderRadius:'0' }}/>,
                    <span key='delimeter'>&nbsp;-&nbsp;</span>,
                    <FormControl type='text' placeholder='Suffix'  key='suffix' onChange={this.handleSuffixChange} onKeyPress={positivenumbers}  style={{ minWidth:'100px',borderRadius:'0' }}/>
                  ])
                }
                <Button onClick={this.handleSearch} style={{ color:orange, marginLeft:'-2px', minHeight:'36px' }} disabled = {this.disableSearchButton()}>
                      <i className={searchIcon} aria-hidden="true" />
                </Button>
              
              </FormGroup>
            </div>
          </Col>
        </Row>
        {
          (nbrOfAthletes == 0) && searchDone && 
          (
           <div>
            <span style={styles.notFound}>
              <i className='fa fa-info-circle' aria-hidden='true'/>
              &nbsp;&nbsp;No athletes found...
            </span>
           </div>
          ) 
        }
        {
         (nbrOfAthletes > 0) && 
          (
            <Athletes bowlers={athletes}  token={token}/>
          )
        }     
      </ContentWrapper>        
    )
  }
}
Athlete.propTypes = {
  oidc: PropTypes.object
}
const mapStateToProps = ({  oidc }) => {
	return {
		oidc: { ...oidc }
	}
}
export default connect(mapStateToProps,null)(Athlete)




// WEBPACK FOOTER //
// ./src/components/pages/Athlete/index.js